import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const state = {
    client_key: '', //client public key
    intent_key: '', //payment intent key
    item_charge: '', //final item charge for the user (0 - first free month, monthly / yearly standard pricing + tax)
    subscription: {},
    update_subscription: {},
    success_flag: '', //indicator for accessing payment success page
    free_month: '',
    update_cc: '', //csOrderNo being passed here for change-credit-card functionality
    update_cc_result: '',
    auto_sync_subscription: '', // Will be filled if detected no active subscription. result would be indicator if sync is done, not applicable or failed
    pending_auto_sync: '',
    read_agreement: '',
    subscription_info: {},
    receipt_source: {}, // This determines where the users should get their receipts (external/shop's receipt page)
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
